import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';
import RefineYourGoalStep from './refine-your-goal-step';

interface RefineYourGoalStepContainerProps {
  handleModalClose: () => void;
  saveCurrentStepDetails?: (payload: any) => void;
}

const RefineYourGoalStepContainer: React.FC<RefineYourGoalStepContainerProps> = ({
  handleModalClose,
  saveCurrentStepDetails,
}) => {
  const {
    data: { goalRefinementQuestions },
  } = useSelector((state: RootState) => state?.sequence?.generateAiSeqModal);

  return (
    <RefineYourGoalStep
      handleModalClose={handleModalClose}
      goalRefinementQuestions={goalRefinementQuestions}
      saveCurrentStepDetails={saveCurrentStepDetails}
    />
  );
};

export default memo(RefineYourGoalStepContainer);
